import axios from "axios";
import { getApiUrl } from "../../../config";

const pluginUrl = (pluginId) => getApiUrl() + "/plugin-admin/" + encodeURIComponent(pluginId);

export function requestGetPluginAdminCatalog() {
    return axios.request({
        method: "get",
        url: getApiUrl() + "/plugin-admin",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetPluginClients(pluginId) {
    return axios.request({
        method: "get",
        url: pluginUrl(pluginId) + "/clients",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestGetPluginAvailableClients(pluginId) {
    return axios.request({
        method: "get",
        url: pluginUrl(pluginId) + "/clients/available",
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestEnablePluginClient(pluginId, clientId) {
    return axios.request({
        method: "post",
        url: pluginUrl(pluginId) + "/clients/" + encodeURIComponent(clientId),
        withCredentials: true,
        crossorigin: true,
    });
}

export function requestDisablePluginClient(pluginId, clientId) {
    return axios.request({
        method: "delete",
        url: pluginUrl(pluginId) + "/clients/" + encodeURIComponent(clientId),
        withCredentials: true,
        crossorigin: true,
    });
}
